<template>
  <span ref="target">
    <slot name="target"></slot>

    <div ref="tooltip" style="position:relative" v-show="show">
      <a href @click.prevent="close" v-if="interactive">
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
          style="width: 25px; height: 25px; position: absolute; top: 15px; right: 10px;"
        >
          <path
            fill="currentColor"
            d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
          />
        </svg>
      </a>

      <div
        style="box-shadow: 0 0 25px rgba(0,0,0,.15); background:white; padding: 15px; line-height: 1.5;"
      >
        <slot name="suggestions"></slot>
      </div>
    </div>
  </span>
</template>

<script>
import tippy from "tippy.js";
import "tippy.js/dist/border.css";

export default {
  props: {
    show: { default: false },
    interactive: { default: true },
    trigger: { default: "manual" },
  },

  data() {
    return {
      tippy: null,
    };
  },

  watch: {
    show(show) {
      if (this.interactive) {
        show ? this.open() : this.close();
      }
    },
  },

  methods: {
    open() {
      this.tippy.show();
    },
    close() {
      this.tippy.hide();
    },
  },

  mounted() {
    this.tippy = tippy(this.$refs.target, {
      content: this.$refs.tooltip,
      arrow: tippy.roundArrow,
      trigger: this.trigger,
      hideOnClick: false,
      interactive: this.interactive,
      interactiveBorder: 30,
    });
  },
};
</script>
